































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../system/mixins";
import { PatientProfileInformation, PatientProfileItem } from "../../../../domain/patient";
import PatientProfileEditor from "./PatientProfileEditor.vue";
import { DomainRegistry } from "../../../../domain";

@Component({
  components: {
    editor: PatientProfileEditor,
  },
})
export default class PatientProfileEditDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      items: [] as PatientProfileItem[],
      result: null as PatientProfileInformation,
      selectedItem: null as PatientProfileItem,
      patientId: null as string,
      isProcessing: false,
    };
  }
  items: PatientProfileItem[];
  result: PatientProfileInformation;
  selectedItem: PatientProfileItem;
  patientId: string;
  isProcessing: boolean;

  $refs!: {
    editor: PatientProfileEditor
  };

  async show(patientId: string, info: PatientProfileInformation): Promise<PatientProfileInformation> {
    if (!info || !info.items) { return null; }
    if (info.isInvalid) { throw new Error("有効な患者プロフィールではありません。"); }
    return this.showModal(async () => {
      this.patientId = patientId;
      this.result = null;
      this.selectedItem = null;
      this.items = info.items;
      this.isProcessing = false;
      await this.waitHidden();
      return this.result;
    });
  }

  setResultAndClose(): void {
    const items = this.getEditedItems();
    this.result = new PatientProfileInformation(items);
    this.isVisible = false;
  }

  getEditedItems(): PatientProfileItem[] {
    if (!this.items) { return []; }
    const items: PatientProfileItem[] = [];
    for (const item of this.items) {
      if (!item || !item.name) { continue; }
      const found = items.find(i => i.name === item.name);
      if (found) {
        this.$warn("エラー", "名称が重複している項目があります。");
        // TODO:後勝ちのほうがよい？
        continue;
      }
      items.push(item);
    }
    return items;
  }

  get isSelected(): boolean {
    return this.selectedItem && (0 <= this.items.indexOf(this.selectedItem));
  }

  close(): void {
    this.result = null;
    this.isVisible = false;
  }

  itemUpdated(index: number, item: PatientProfileItem): void {
    this.items.splice(index, 1, item);
  }

  handleItemSelected(item: PatientProfileItem): void {
    this.selectedItem = item;
  }

  addNewItem(): void {
    const item = new PatientProfileItem();
    this.items.splice(this.items.length, 0, item);
    this.$nextTick(() => { 
      this.$refs.editor.selectLastItem(item);
    });
  }

  removeSelectedItem(): void {
    if (this.selectedItem === null) { return; }
    const index = this.items.indexOf(this.selectedItem);
    if (index < 0) { return; }
    this.items.splice(index, 1);
  }

  updateAndClose(): void {
    if (this.isProcessing) { return; }
    const items = this.getEditedItems();
    const info = new PatientProfileInformation(items);
    const repository = DomainRegistry.patient.getPatientProfileRepository();
    this.isProcessing = true;
    repository.updatePatientProfileInformation(this.patientId, info)
    .then(() => {
      this.isProcessing = false;
      this.result = new PatientProfileInformation(items);
      this.isVisible = false;
    }).catch(e => {
      this.isProcessing = false;
      this.$error("エラー", "患者プロフィールの更新処理中にエラーが発生しました。", e);
    });
  }
}
